import { ActionCreator } from '@sendoutcards/core'

export const setTourId = ActionCreator(
  'SET_TOUR_ID',
  (tourId: string | undefined) => ({
    tourId,
  }),
)
